import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService, LoaderState } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {

  state$!: Observable<LoaderState>;

  constructor(private loaderService: LoaderService) {
    this.state$ = this.loaderService.state$;
  }
}
